export interface Category {
  id: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: "all",
    name: "全网热榜",
    desc: "不看分类，直接看今天全网围观热度最高的焦点事件。",
    icon: "ri-fire-line",
    count: 128,
  },
  {
    id: "ent",
    name: "娱乐圈",
    desc: "镜头内外的动态与回应，围观热度往往来得最快。",
    icon: "ri-star-line",
    count: 46,
  },
  {
    id: "film",
    name: "影视综艺",
    desc: "剧集结局、综艺名场面、开播口碑，追更党的主战场。",
    icon: "ri-film-line",
    count: 32,
  },
  {
    id: "star",
    name: "网红达人",
    desc: "直播间、短视频平台上的焦点人物与话题走向。",
    icon: "ri-live-line",
    count: 21,
  },
  {
    id: "society",
    name: "社会热议",
    desc: "被广泛讨论的公共话题与民生焦点，理性围观。",
    icon: "ri-community-line",
    count: 17,
  },
  {
    id: "life",
    name: "生活杂谈",
    desc: "吃喝玩乐、消费避坑、生活方式里的新鲜讨论。",
    icon: "ri-leaf-line",
    count: 12,
  },
];

export const categoryMap: Record<string, Category> = categories.reduce(
  (acc, item) => {
    acc[item.id] = item;
    return acc;
  },
  {} as Record<string, Category>,
);